import { Component, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { Const } from '@blcloud/bl-common';

/**
 * アプリケーションコンポーネント
 */
@Component({
  selector: 'app-root',
  styleUrls: ['app.component.scss'],
  templateUrl: 'app.component.html'
})
export class AppComponent implements OnInit {

  /** フレーム(ヘッダ/フッタ)を表示しないルーティングパス */
  private readonly NO_FRAME_ROUTE_PATHS = [
    Const.RoutePath.LOGIN,
    Const.RoutePath.WIZARD
  ];

  /** フレーム表示有無 */
  _showFrame = false;

  /**
   * コンストラクタ
   * @param router Router
   */
  constructor(private router: Router) {}

  ngOnInit() {
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    )
    .subscribe(
      (event: NavigationEnd) => {
        const regExp = new RegExp(`^(${this.NO_FRAME_ROUTE_PATHS.join('|')})`);
        this._showFrame = !regExp.test(event.urlAfterRedirects);
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts